var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-button",style:(_vm.isFixed ? _vm.fixedStyle : {}),attrs:{"isFixed":_vm.isFixed}},[_c('ion-button',{attrs:{"mode":"ios","expand":"full","color":"primary","disabled":_vm.disabled},on:{"click":_vm.clickEvent}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }